export const initialState = {
  formCompletionMetrics: [],
  filteredFormCompletionMetrics: [],
  isLoading: false,
  searchText: "",
  filterModel: {},
  hasError: false,
  errorMessage: "",
  formResponseData: null,
  isResponseModalOpen: false
};